'use client';

import { motion } from 'framer-motion';

interface GlowOrbProps {
  /** CSS color value, e.g. 'rgba(59, 130, 246, 0.25)' */
  color: string;
  /** Diameter in px or CSS value */
  size: number;
  /** Position from left (%) */
  x: number;
  /** Position from top (%) */
  y: number;
  /** Blur radius in px */
  blur?: number;
  /** Drift range in px — orb drifts randomly within this radius */
  drift?: number;
  /** Full animation cycle duration in seconds */
  duration?: number;
}

export function GlowOrb({
  color,
  size,
  x,
  y,
  blur = 80,
  drift = 30,
  duration = 20,
}: GlowOrbProps) {
  return (
    <motion.div
      className="absolute rounded-full pointer-events-none"
      style={{
        width: size,
        height: size,
        left: `${x}%`,
        top: `${y}%`,
        background: color,
        filter: `blur(${blur}px)`,
        transform: 'translate(-50%, -50%)',
      }}
      animate={{
        x: [0, drift, -drift * 0.6, drift * 0.3, 0],
        y: [0, -drift * 0.7, drift * 0.4, -drift, 0],
        scale: [1, 1.08, 0.95, 1.04, 1],
      }}
      transition={{
        duration,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
    />
  );
}
